import { VFC } from 'react';
import { useFormikContext } from 'formik';
import { useRfiForm } from '../../RfiFormProvider';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../constants/issue-attribute-names';
import { StatusOption } from '../../../hooks/useStatusOptions';
import { RfiCreateFormValues } from '../../types';
import { PureStatusField } from './PureStatusField';

export const Status: VFC = () => {
  const formik = useFormikContext<RfiCreateFormValues>();
  const { mandatoryFields, isSubmitting, refs, setPrevSelectedTransition, setSelectedTransition } =
    useRfiForm();

  const fieldName = ISSUE_ATTRIBUTE_NAMES.STATUS;
  const isFieldsMandatory = mandatoryFields.includes(fieldName);
  const errorMessage = formik.touched.status && formik.errors.status;
  const { rfiTypeId, status } = formik.values;

  const handleOnChangeTransition = (selectedTransition: StatusOption | undefined) => {
    if (selectedTransition) {
      formik.setFieldValue(fieldName, selectedTransition.serverStatus);
      setSelectedTransition((prevTransition) => {
        setPrevSelectedTransition(prevTransition);
        return selectedTransition;
      });
    }
  };

  return (
    <PureStatusField
      required={isFieldsMandatory}
      isError={!!errorMessage}
      ref={refs[fieldName]}
      value={status}
      disabled={isSubmitting}
      rfiTypeId={rfiTypeId}
      onChange={handleOnChangeTransition}
    />
  );
};
